import { Option } from '@/types/Option';

export default (entries: string[]): Option[] => entries.map((v) => ({ text: v, value: v }));
